import { array, boolean, literal, number, object, string, z } from "zod";

import { LadyMinV2DTOPhotoSrcs } from "@/models/lady-dtos";

const SweetOrHotLadyPhotoTypes = literal("PHOTO_LADY");

export const SweetOrHotLadyRaw = object({
  firstName: string(),
  lastName: string(),
  mainPhotoID: number(),
  isVideochatAvailable: boolean(),
  isBirthdaySoon: boolean(),
  isNewProfile: boolean(),
  agencyId: number(),
  from: string(),
  isOnline: boolean(),
  id: number(),
  hasIntroVideo: boolean(),
  mainPhotoDTO: object({
    photoType: SweetOrHotLadyPhotoTypes,
    userId: number(),
    mediaName: string().optional(),
  }).optional(),
  isGiftsAvailable: boolean(),
});

export type SweetOrHotLadyRaw = z.infer<typeof SweetOrHotLadyRaw>;

export const SweetOrHotLady = SweetOrHotLadyRaw.extend({
  photoSrcs: LadyMinV2DTOPhotoSrcs,
});

export type SweetOrHotLady = z.infer<typeof SweetOrHotLady>;

export const SweetOrHotDataMapRaw = object({
  result: array(SweetOrHotLadyRaw),
  actualDate: string(),
});

export const SweetOrHotDataMap = SweetOrHotDataMapRaw.extend({
  result: array(SweetOrHotLady),
});

export const SweetOrHotLadiesDTORaw = object({
  requestDTO: object({
    processorClass: literal("SweetOrHot"),
    dataMap: SweetOrHotDataMapRaw,
  }),
});

export type SweetOrHotLadiesDTORaw = z.infer<typeof SweetOrHotLadiesDTORaw>;

export const SweetOrHotLadiesDTO = SweetOrHotLadiesDTORaw.extend({
  requestDTO: object({
    dataMap: SweetOrHotDataMap,
  }),
});

export type SweetOrHotLadiesDTO = z.infer<typeof SweetOrHotLadiesDTO>;
